import React, { useState, useEffect } from 'react';
import Header from './Header';
import MobileHeader from './MobileHeader';
import Footer from './Footer';

export default function Layout(props) {
  const { children, route } = props;
  const [openMobileHeader, setOpenMobileHeader] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleMobileHeader = () => {
    // Imitates the above line
    setOpenMobileHeader(!openMobileHeader);
  };

  return (
    <div style={{ width: '100%', height: 'auto' }}>
      <Header
        route={route}
        toggleMobileHeader={toggleMobileHeader}
        {...props}
      />
      <div className="container">
        <MobileHeader
          toggleMobileHeader={toggleMobileHeader}
          openMobileHeader={openMobileHeader}
          {...props}
        />
        {children}
        <Footer {...props} />
      </div>
    </div>
  );
}
